module.exports = __webpack_public_path__ + "img/img10.cce3fb5e.svg";